import React, { Component } from 'react';
import { t } from 'i18next';

import LineGraph from '../LineGraph/LineGraph';
// import { getPlotService } from '../../../services/testResultsService';

class FailurePredictionGraphComponent extends Component {
  constructor(props) {
    super(props);
    const { threshold = false } = this.props;
    this.state = {
      // data: [],
      threshold,
    };
    this.lineGroup = React.createRef();
    this.draggable = React.createRef();
    this.line = React.createRef();
    this.graph = React.createRef();
  }

  componentDidMount() {
    // const { fromPlotService } = this.props;
    // let jobName = "611PctDiffCDF";
    // // Request plot data and setup LineChart graph data

    // getPlotService(jobName).then((requestData) => {
    //   // console.log(requestData)
    //   // If using cumalative distribution as jobname multiple y by 100
    //   requestData['X-Axis'].reverse();
    //   const data = requestData['X-Axis'].map((dataXPoint, index) => ({
    //     x: parseInt(dataXPoint, 10),
    //     y: parseInt(requestData['Y-Axis'][index], 10)
    //   }));

    //   // propsData={dataFromS3['x-axis'].map((dataXPoint, index) => ({
    //   //   x: new Date(dataXPoint),
    //   //   y: parseInt(dataFromS3.anomaly_score[index], 10),
    //   // }))}
    //   this.setState({
    //     data
    //   });
    // }).catch((error) => {
    //   console.error("Error", error);
    // });
  }

  // Threshold handler from draggable line on graph, calls callback from FailurePrediction
  handleChange = (e) => {
    const { changeThreshold } = this.props;
    this.setState({
      threshold: e.target.value,
    }, changeThreshold(e.target.value));
  }

  // Handle Drag event
  handleDrag = (e) => {
    const resetEvents = () => {
      this.draggable.current.onmousemove = null;
      this.draggable.current.onmouseup = null;
      this.line.current.onmouseup = null;
      this.line.current.onmousemove = null;
    };
    resetEvents();

    e.preventDefault();

    const {
      changeThreshold,
      height = 300,
    } = this.props;
    // Set draggable event and calculate newThreshold
    this.draggable.current.onmousemove = (x) => {
      // console.log(x)
      // Numbers based on graph height and convert to percentage. (Height: 350px + 10px of padding)
      const newThreshold = parseInt(((height - 50) - x.offsetY) / ((height - 50) / 100), 10);
      let threshold = newThreshold;
      // console.log(dsnTable);
      // console.log(newThreshold);
      if (newThreshold < 10) threshold = 10;
      if (x.offsetY < 20) threshold = 95;
      // console.log('after limit', threshold);
      this.setState({
        threshold,
      }, changeThreshold(threshold));
    };

    // Remove dragging events when leaving mouse draggable group and lifting click
    this.draggable.current.onmouseup = resetEvents;
    this.line.current.onmouseup = resetEvents;
    this.lineGroup.current.onmouseleave = resetEvents;
  }

  render() {
    const {
      fromPlotService = true,
      propsData,
      width = 500,
      height = 300,
      failureData
    } = this.props;
    const {
      // data,
      threshold = false,
    } = this.state;
    // console.log(fromPlotService)
    // console.log(data || propsData);
    // console.log(propsData);
    // if (data.length === 0) data = propsData
    // data && data.length > 0
    // console.log(height);
    // console.log(threshold);
    // console.log((height - 55) - (height - 60) * (threshold / 100));

    return (
      <div className="failure-prediction-graph"
        ref={(c) => { this.graph = c; }}
      >
        {
          fromPlotService && failureData && failureData.length > 0 ? (
            <LineGraph data={failureData}
              width={(width || this.graph.offsetWidth)}
              height={height}
              xAt0
              linearScale={fromPlotService}
              textLine={t('tensorAnalytics.graphs.cdf.label')}
              yAxisTitle={t('tensorAnalytics.graphs.cdf.yAxis')}
              colorLine="#AAC5EA"
            />
          ) : (
            <LineGraph data={propsData}
              // width={(width || this.graph.offsetWidth)}
              height={height}
              xAt0
              linearScale={fromPlotService}
              textLine={t('tensorAnalytics.graphs.cdf.label')}
              yAxisTitle={t('tensorAnalytics.graphs.cdf.yAxis')}
              colorLine="#AAC5EA"
            />
          )
          // failureData && failureData.length > 0 && (
          //   <LineGraph data={! fromPlotService ? propsData : failureData}
          //     width={(width || this.graph.offsetWidth)}
          //     height={height}
          //     xAt0
          //     linearScale={fromPlotService}
          //     textLine={t('tensorAnalytics.graphs.cdf.label')}
          //     yAxisTitle={t('tensorAnalytics.graphs.cdf.yAxis')}
          //     colorLine="#AAC5EA"
          //   />
          // )
        }
        {threshold && (
          <svg version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            className="line"
            aria-labelledby="title"
            role="img"
            style={{
              height,
              width: (width || this.graph.offsetWidth),
            }}
          >
            <g className="lineGroup"
              ref={this.lineGroup}
            >
              <line x1="0"
                y1={(height - 50) - (height - 70) * (threshold / 100)}
                x2={(width || this.graph.offsetWidth)}
                y2={(height - 50) - (height - 70) * (threshold / 100)}
                style={{
                  stroke: 'transparent',
                  strokeWidth: 60,
                }}
                ref={this.draggable}
              />
              <text x={(width - 35 || this.graph.offsetWidth) - 35}
                y={(height - 55) - (height - 60) * (threshold / 100)}
                className="failure-percentage"
              >
                {`%${threshold}`}
              </text>
              <line x1="0"
                onMouseDown={this.handleDrag}
                y1={(height - 50) - (height - 70) * (threshold / 100)}
                x2={(width || this.graph.offsetWidth)}
                y2={(height - 50) - (height - 70) * (threshold / 100)}
                style={{
                  cursor: 'move',
                  stroke: '#FAA05B',
                  strokeWidth: 5,
                }}
                ref={this.line}
              />
            </g>
          </svg>
        )}
      </div>
    );
  }
}

export default FailurePredictionGraphComponent;
